export enum MeetingRecurrenceFrequency {
    Weekly = 1,
    Monthly = 2,
}

export const MEETING_RECURRENCE_FREQUENCY_LABELS: Record<
    MeetingRecurrenceFrequency,
    string
> = {
    [MeetingRecurrenceFrequency.Weekly]: 'Weekly',
    [MeetingRecurrenceFrequency.Monthly]: 'Monthly',
};
